export default __webpack_public_path__ + "static/Europe_Hero_Animation_updated-4bdac068a55d8d7293cf10b4bef1166c.mp4";